class SeqNumUtil {
  private static num: number = 0;
  static get() {
    return ++SeqNumUtil.num;
  }
}
export default SeqNumUtil;
